import React, { useState, useEffect, useCallback } from 'react';
import emailApi from '../services/emailApi';

const LogsViewer: React.FC = () => {
  const [logs, setLogs] = useState<string[]>([]);
  const [level, setLevel] = useState('ALL');
  const [search, setSearch] = useState('');
  const [lines, setLines] = useState(100);

  const loadLogs = useCallback(async () => {
    try {
      const data = await emailApi.getLogs(lines, level, search);
      setLogs((data as Record<string, unknown>).data as string[] || []);
    } catch {
      // silently fail
    }
  }, [lines, level, search]);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  const getLineColor = (line: string) => {
    if (line.includes('[ERROR]')) return '#e74c3c';
    if (line.includes('[WARNING]')) return '#f39c12';
    if (line.includes('[INFO]')) return '#27ae60';
    return '#666';
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 style={{ margin: 0, fontSize: '20px' }}>Loguri Aplicatie</h2>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <select value={level} onChange={e => setLevel(e.target.value)} style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid var(--border-color, #334155)', fontSize: '13px', backgroundColor: 'var(--card-bg, #1e293b)', color: 'var(--text-primary, #e2e8f0)' }}>
            <option value="ALL">Toate</option>
            <option value="INFO">Info</option>
            <option value="WARNING">Warning</option>
            <option value="ERROR">Error</option>
          </select>
          <select value={lines} onChange={e => setLines(Number(e.target.value))} style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid var(--border-color, #334155)', fontSize: '13px', backgroundColor: 'var(--card-bg, #1e293b)', color: 'var(--text-primary, #e2e8f0)' }}>
            <option value={50}>50 linii</option>
            <option value={100}>100 linii</option>
            <option value={200}>200 linii</option>
            <option value={500}>500 linii</option>
          </select>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Cauta..." onKeyDown={e => e.key === 'Enter' && loadLogs()}
            style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid var(--border-color, #334155)', fontSize: '13px', width: '150px', backgroundColor: 'var(--card-bg, #1e293b)', color: 'var(--text-primary, #e2e8f0)' }} />
          <button onClick={loadLogs} style={{ padding: '6px 14px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>Refresh</button>
          <button onClick={async () => { await emailApi.clearLogs(); loadLogs(); }} style={{ padding: '6px 14px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>Sterge</button>
        </div>
      </div>
      <div style={{ backgroundColor: '#1a1a2e', borderRadius: '12px', padding: '16px', maxHeight: '600px', overflow: 'auto', fontFamily: 'monospace', fontSize: '12px' }}>
        {logs.length === 0 ? (
          <div style={{ color: '#999', textAlign: 'center', padding: '40px' }}>Niciun log gasit</div>
        ) : (
          logs.map((line, i) => (
            <div key={i} style={{ color: getLineColor(line), padding: '2px 0', borderBottom: '1px solid rgba(255,255,255,0.05)', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {line}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LogsViewer;
